import styled from 'styled-components';
import { ReferenceAddressComponent } from './ReferenceAddressComponent';
import { ReferenceAddress } from './types';
import { colors } from '@ardoq/design-tokens';
import { text2Bold } from '@ardoq/typography';

const Title = styled.label`
  color: ${colors.textOnInvertedSubtle};
  ${text2Bold}
`;
interface CollapsedReferenceAddressesProperties {
  title: string;
  addresses: ReferenceAddress[];
}
const CollapsedReferenceAddress = ({
  title,
  addresses,
}: CollapsedReferenceAddressesProperties) => (
  <>
    <Title>{title}</Title>
    {addresses.map(address => (
      <ReferenceAddressComponent
        key={address
          .map(
            (item, index) => `${item.nodeInfo.name}-${item.relation}_${index}`
          )
          .join(',')}
        address={address}
      />
    ))}
  </>
);
export { CollapsedReferenceAddress };
